<!-- <template>
  <div v-if="isTrading">
    <button :class="['displayed', { dark: isDarkMode }]" @click="toggleDarkMode">
      display
    </button>
  </div>
</template> -->
<template>
  <div v-if="isTrading" class="theme-switch-container">
    <div class="theme-switch">
      <!-- 달(다크 모드) 버튼: isDarkMode가 true일 때 활성화 -->
      <button
        class="theme-btn btn-dark"
        :class="{ active: isDarkMode }"
        @click="setDarkMode(true)"
      >
        <span class="sr-only">Dark Mode</span>
      </button>

      <!-- 해(라이트 모드) 버튼: isDarkMode가 false일 때 활성화 -->
      <button
        class="theme-btn btn-light"
        :class="{ active: !isDarkMode }"
        @click="setDarkMode(false)"
      >
        <span class="sr-only">Light Mode</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, nextTick, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
const store = useStore();
const route = useRoute();
const isDarkMode = computed(() => store.getters["displayed/isDarkMode"]);
const mainPath = computed(() => {
  return route.path.split("/")[1];
});
const isTrading = computed(() => {
  const path = route.path.split("/")[1];
  return (
    path === "trading" || path === "trading-chart" || path === "trading-test"
  );
});

// function toggleDarkMode() {
//   store.commit("displayed/setIsDarkMode", !isDarkMode.value);
//   if (isDarkMode.value) {
//     document.documentElement.setAttribute("data-theme", "dark");
//   } else {
//     document.documentElement.removeAttribute("data-theme");
//   }
// }

function setDarkMode(isDark) {
  // 현재 상태와 같으면 실행 안 함
  if (isDarkMode.value === isDark) return;

  store.commit("displayed/setIsDarkMode", isDark);

  if (isDark) {
    document.documentElement.setAttribute("data-theme", "dark");
  } else {
    document.documentElement.removeAttribute("data-theme");
  }
}

watch(mainPath, () => {
  if (isTrading.value) {
    store.commit("displayed/initialIsDarkMode");
  } else {
    store.commit("displayed/setIsDarkMode", true);
  }
  if (isDarkMode.value) {
    document.documentElement.setAttribute("data-theme", "dark");
  }
});
</script>

<style lang="scss" scoped>
// .displayed {
//   text-indent: -9999px;
//   width: 25px;
//   height: 25px;
//   background: url("@/assets/images/common/light.png") no-repeat center center;
//   background-size: cover;

//   &:hover {
//     background: url("@/assets/images/common/light_active.png") no-repeat center center;
//     background-size: cover;
//   }

//   &.dark {
//     background: url("@/assets/images/common/dark.png") no-repeat center center;
//     background-size: cover;
//     background-size: 80%;

//     &:hover {
//       background: url("@/assets/images/common/dark_active.png") no-repeat center center;
//       background-size: cover;
//       background-size: 80%;
//     }
//   }
// }

.theme-switch-container {
  display: inline-block;
}

.theme-switch {
  display: flex;
  align-items: center;
  gap: 4px;
}

.theme-btn {
  width: 44px;
  height: 38px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  background: var(--logout-color);
  transition: all 0.3s ease;

  display: flex;
  justify-content: center;
  align-items: center;

  background-repeat: no-repeat;
  background-position: center center;
  background-size: 20px;
}

.btn-dark {
  background-image: url("@/assets/images/common/dark.svg");
}

.btn-light {
  background-image: url("@/assets/images/common/light.svg");
}

.theme-btn.active {
  background-color: var(--primary-color);

  &.btn-dark {
    background-image: url("@/assets/images/common/dark_active.svg");
  }

  &.btn-light {
    background-image: url("@/assets/images/common/light_active.svg");
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
